// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-37b86ad5] {\n  color: #909399;\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: 12px;\n}\n.sub-line[data-v-37b86ad5] {\n  color: #909399;\n  font-size: 12px;\n}\n.danger-text[data-v-37b86ad5] {\n  color: #f56c6c;\n}\n.pager[data-v-37b86ad5] {\n  margin-top: 12px;\n  text-align: right;\n}\n.selWidthSm[data-v-37b86ad5] {\n  width: 150px;\n}\n.selWidth[data-v-37b86ad5] {\n  width: 200px;\n}", ""]);
// Exports
module.exports = exports;
